import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-recommendations-icon',
  templateUrl: './recommendations-icon.component.html',
  styleUrls: ['./recommendations-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationsIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
